import React from 'react';
import { Box, IconButton, Typography, Tooltip } from '@mui/material';
import { Info as InfoIcon } from '@mui/icons-material';

const InfoButton = ({ helpText, onClick, style = {}, label = '', labelAlignment, verticalAlign = false }) => {
    return (
        <Tooltip title={helpText} arrow>
            <Box
                onClick={onClick}
                sx={{
                    display: 'flex',
                    flexDirection: verticalAlign ? 'column' : 'row',  // Adjust layout based on verticalAlign prop
                    alignItems: 'center',
                    cursor: 'pointer',
                    color: 'blue',
                    ...style,
                }}
            >
                {labelAlignment === 'right' || verticalAlign ? (
                    <>
                        <IconButton sx={{ p: 0, color: 'blue', }}>
                            <InfoIcon fontSize="small" />
                        </IconButton>
                        <Typography sx={{ fontSize: '14px', mt: verticalAlign ? 1 : 0, ml: verticalAlign ? 0 : 1 }}>
                            {label}
                        </Typography>
                    </>
                ) : (
                    <>
                        <Typography sx={{ fontSize: '14px', mb: verticalAlign ? 1 : 0, mr: verticalAlign ? 0 : 1 }}>
                            {label}
                        </Typography>
                        <IconButton sx={{ p: 0, color: 'blue', paddingRight:2 }}>
                            <InfoIcon fontSize="small" />
                        </IconButton>
                    </>
                )}
            </Box>
        </Tooltip>
    );
};

export default InfoButton;
